import { fetchData } from '@databases/database-state';

import { rejectOnError } from './utils';

export async function addContentLabels(
  contentId: string,
  labels: string[]
): Promise<void> {
  if (labels.length === 0) {
    return;
  }

  await fetchData(`/rest/api/content/${encodeURIComponent(contentId)}/label`, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
    },
    body: JSON.stringify(labels.map((label) => ({ prefix: 'global', name: label }))),
  }).then(rejectOnError);
}

export async function removeContentLabel(
  contentId: string,
  label: string
): Promise<void> {
  await fetchData(
    `/rest/api/content/${encodeURIComponent(contentId)}/label?${new URLSearchParams({
      name: label,
    })}`,
    {
      method: 'DELETE',
    }
  ).then(rejectOnError);
}
